import React from 'react';

const PasswordStrengthIndicator = ({ strength, checks }) => {
  const getStrengthColor = (strength) => {
    switch (strength) {
      case 'strong':
        return 'text-green-600 bg-green-100';
      case 'medium':
        return 'text-yellow-600 bg-yellow-100';
      case 'weak':
        return 'text-red-600 bg-red-100';
      default:
        return 'text-gray-600 bg-gray-100';
    }
  };

  const getStrengthText = (strength) => {
    switch (strength) {
      case 'strong':
        return '強';
      case 'medium':
        return '中';
      case 'weak':
        return '弱';
      default:
        return '未知';
    }
  };

  return (
    <div className="mt-2">
      <div className="flex items-center space-x-2 mb-2">
        <span className="text-sm font-medium">密碼強度:</span>
        <span className={`px-2 py-1 rounded text-xs font-medium ${getStrengthColor(strength)}`}>
          {getStrengthText(strength)}
        </span>
      </div>
      
      <div className="space-y-1">
        <div className={`flex items-center text-xs ${checks.length ? 'text-green-600' : 'text-red-600'}`}>
          <span className="mr-2">✓</span>
          <span>至少8個字符</span>
        </div>
        <div className={`flex items-center text-xs ${checks.lowercase ? 'text-green-600' : 'text-red-600'}`}>
          <span className="mr-2">✓</span>
          <span>包含小寫字母</span>
        </div>
        <div className={`flex items-center text-xs ${checks.uppercase ? 'text-green-600' : 'text-red-600'}`}>
          <span className="mr-2">✓</span>
          <span>包含大寫字母</span>
        </div>
        <div className={`flex items-center text-xs ${checks.number ? 'text-green-600' : 'text-red-600'}`}>
          <span className="mr-2">✓</span>
          <span>包含數字</span>
        </div>
        <div className={`flex items-center text-xs ${checks.special ? 'text-green-600' : 'text-red-600'}`}>
          <span className="mr-2">✓</span>
          <span>包含特殊字符</span>
        </div>
      </div>
    </div>
  );
};

export default PasswordStrengthIndicator; 